// Product families: opening of the menus (hover, click, keyboard).
// Independent of the form scripts: the products remain the same buttons.
export const initFamilies = (root) => {
  const groups = Array.from(root.querySelectorAll('.plist .pgroup'))
  if (!groups.length) return
  const close = (g) => {
    g.classList.remove('open')
    g.querySelector('.pfam').setAttribute('aria-expanded', 'false')
  }
  function refresh(list) {
    list.querySelectorAll('.pgroup').forEach((g) => {
      const on = g.querySelector('.tile.on'),
        sub = g.querySelector('.pfam-sub')
      g.classList.toggle('has-sel', !!on)
      sub.textContent = on ? on.textContent.trim() : sub.dataset.default
    })
  }
  groups.forEach((g) => {
    const head = g.querySelector('.pfam'),
      tiles = Array.from(g.querySelectorAll('.tile'))
    head.addEventListener('click', (e) => {
      if (tiles.length === 1) {
        tiles[0].click() // "Other": direct selection
        return
      }
      const open = !g.classList.contains('open')
      groups.forEach((o) => o !== g && close(o))
      g.classList.toggle('open', open)
      head.setAttribute('aria-expanded', String(open))
      if (open && e.detail === 0) tiles[0].focus() // opened with the keyboard
    })
    tiles.forEach((t, i) => {
      t.setAttribute('role', 'menuitem')
      t.addEventListener('click', () => {
        close(g)
        g.classList.add('picked')
        setTimeout(() => refresh(g.closest('.plist')), 0)
      })
      t.addEventListener('keydown', (e) => {
        if (e.key === 'ArrowDown') {
          e.preventDefault()
          ;(tiles[i + 1] || tiles[0]).focus()
        }
        if (e.key === 'ArrowUp') {
          e.preventDefault()
          ;(tiles[i - 1] || tiles[tiles.length - 1]).focus()
        }
      })
    })
    g.addEventListener('mouseleave', () => g.classList.remove('picked'))
    g.addEventListener('keydown', (e) => {
      if (e.key === 'Escape') {
        close(g)
        head.focus()
      }
    })
  })
  document.addEventListener('click', (e) =>
    groups.forEach((g) => {
      if (!g.contains(e.target)) close(g)
    })
  )
  root.querySelectorAll('.plist').forEach(refresh)
}
